<template>
    <div>
        <menu_c/>
        <div>
            <a-row style="padding: 20px 20px">
                <a-col :md="12" :sm="24" style="padding: 0 20px">
                    <a-image-preview-group>
                        <a-row>
                            <a-col :span="24" style="text-align: center">
                                <a-image :src="product.src"/>
                            </a-col>
                        </a-row>
                    </a-image-preview-group>
                </a-col>
                <a-col :md="12" :sm="24">
                    <a-row>
                        <a-col :span="24">
                            <h1>{{product.title}}</h1>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="24">
                            <h2>{{product.title}}</h2>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="24">
                            <h2>价格：{{product.title}}</h2>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="24">
                            <h3>型号</h3>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="24" style="text-align: center;padding-top: 10px">
                            <a-space>
                                <!--<a-button type="primary" shape="round" size="large"-->
                                <!--style="color: gray; font-weight: bolder">-->
                                <!--加入购物车-->
                                <!--</a-button>-->
                                <!--<a-button type="primary" shape="round" size="large"-->
                                <!--style="color: red; font-weight: bolder">-->
                                <!--立即购买-->
                                <!--</a-button>-->
                                <a-button type="primary" shape="round" size="large" @click="showModal"
                                          style="color: red; font-weight: bolder">
                                    联系购买
                                </a-button>
                                <a-modal v-model:open="open" title="联系购买" @ok="handleOk" :footer="null">
                                    <p>电话：<a>17610833899</a> <a>13876562330</a></p>
                                    <p>微信：<a>17610833899</a></p>
                                    <p>
                                        <a-image :preview="false" width="150px"
                                                 src="wechat.png"
                                        />
                                    </p>
                                </a-modal>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row>
                <a-col style="padding-top: 20px">
                    <div v-html="product.content"></div>
                </a-col>
            </a-row>
        </div>
        <foot_c/>
    </div>
</template>

<script setup>
    import foot_c from '../../components/foot_c.vue';
    import menu_c from '../../components/menu_c.vue';
    import {onMounted, ref} from 'vue';
    import {API_articleById} from '../../api/api.js'
    import {useRoute} from 'vue-router'

    const route = useRoute();
    const product = ref({});
    const open = ref(false);
    const showModal = () => {
        open.value = true;
    };
    const handleOk = () => {
        open.value = false;
    };
    onMounted(() => {
        var aid = route.query.aid;
        getArticleDetail(aid);
    });

    function getArticleDetail(aid) {
        API_articleById(aid).then(res => {
            if (res.success && res.result) {
                product.value = {
                    ...res.result,
                    src: process.env.VUE_APP_BASE_API + process.env.VUE_APP_GLOB_API_URL + `/sys/common/static/${res.result.pic}`
                }

            }

        });
    }
</script>

<style scoped>
    /* For demo */
    :deep(.slick-slide) {
        text-align: center;
        max-height: 700px;
        /*line-height: 160px;*/
        /*background: darkcyan;*/
        overflow: hidden;
    }

    :deep(.slick-slide h3) {
        color: #fff;
    }

    :deep(.slick-slide img) {
        width: 100%;
        height: 100%;
        object-fit: cover; /* 类似于background-size: cover;的效果 */
    }

</style>